import React, { useState } from 'react'

import { ChronoCard } from './chronoCardModal'
import { useQuery, } from 'react-query';
import { Text, Stack,  Chip,} from '@mantine/core';
import { fetchChronosByMemberID } from '../connections/requests';




export function ChronoList(props) {

    const membreId = props.membre;
    const { data, status } = useQuery(['chrono', membreId], fetchChronosByMemberID);
    const [filter, setValue] = useState(["open", "inProg", "closed"]);

    return (
        <>
            <Chip.Group p={"xs"} position='center' align='center' multiple value={filter} onChange={setValue}>
                <Chip value={'open'} color='green'>Ouverte</Chip>
                <Chip value={'inProg'} color='orange'>En attente</Chip>
                <Chip value={'closed'} color='red'>Fermée</Chip>
            </Chip.Group>

            <Stack>
                {status === "success" ? data.filter(i => filter.includes(i.status)).map((i, index) => (<ChronoCard props={i} key={i._id} />)) : <Text>No Data</Text>}
            </Stack>
        </>
    )
}
